jQuery(document).ready(function($) {
    $('.review_item__remove').click(function() {
        var commentId = $(this).data('comment-id');

            $.ajax({
                type: 'POST',
                url: ajax_del_comments.ajax_url,
                data: {
                    action: 'delete_own_comment',
                    comment_id: commentId
                },
                success: function(response) {
                    if (response.success) {
                        location.reload(); // Оновлює сторінку для відображення змін
                    } else {
                        alert(response.error);
                    }
                }
            });
    });
});
